import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import VueSanitize from 'vue-sanitize'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueSanitize)

import Home from './views/home.vue'
import Clients from './views/clients.vue'
import ResourceServerExample from './views/resource-server.vue'

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Home},
    { path: '/clients', component: Clients},
    { path: '/api', component: ResourceServerExample}
  ],
  base: '/openid-connect/inspector'
})

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})